export const CircleTickIcon = ({ ...props }) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke={props.stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="m12 22c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.5-10 10 4.5 10 10 10z" />
        <path d="m7.75 12 2.83 2.83 5.67-5.65996" />
      </g>
    </svg>
  );
};
